import { createContext } from "react";

export const PromptTemplateContext = createContext({
  setOrgSkuuid: () => {},
  promptTemplates: [],
  isPromptTemplateLoading: false,
});
